<template>
  <div>
    <div :id="this.mapid" class="maptrack"></div>
  </div>
</template>
<script>
import Map from "ol/Map";
import View from "ol/View";
import "ol/ol.css";
import { Vector as VectorSource } from "ol/source";
import ImageLayer from "ol/layer/Image";
import { Vector as VectorLayer } from "ol/layer";
import GeoJSON from "ol/format/GeoJSON";
import Static from "ol/source/ImageStatic";
import { getCenter } from "ol/extent";
import { Select } from "ol/interaction";
import { Fill, Stroke, Style, Text } from "ol/style";
import Projection from "ol/proj/Projection";
var vectorsource;
var vectorlayer;
var select = new Select({
  style: overlayStyle
});
var overlayStyle = function() {
  var styles = {};
  styles["Polygon"] = [
    new Style({
      fill: new Fill({
        color: [255, 255, 255, 0.5]
      })
    }),
    new Style({
      stroke: new Stroke({
        color: [255, 255, 255, 1],
        width: 5
      })
    }),
    new Style({
      stroke: new Stroke({
        color: [0, 153, 255, 1],
        width: 3
      })
    })
  ];
};

var extent = [0, 0, 720, 480];
var projection = new Projection({
  code: "static-image",
  units: "pixels",
  extent: extent
});
var style = new Style({
  fill: new Fill({
    color: "rgba(255, 0, 0, 0.1)"
  }),
  stroke: new Stroke({
    color: "#FF0000",
    width: 3
  }),
  text: new Text({
    font: "16px Calibri,sans-serif",
    fill: new Fill({
      color: "#000"
    }),
    stroke: new Stroke({
      color: "#fff",
      width: 2
    })
  })
});

export default {
  props: {
    obj: {
      type: [String, Number],
      required: false,
      default: 1675
    },
    frame: {
      type: [String, Number],
      required: false,
      default: 176
    },
    mapid: {
      type: String,
      required: false,
      default: "map1"
    },
    mapheight: {
      type: [String, Number],
      required: false,
      default: 480
    },
    mapwidtht: {
      type: [String, Number],
      required: false,
      default: 720
    }
  },
  data: function() {
    return {
      map: null,
      map1: null,
      map2: null
    };
  },
  watch: {
    obj: function() {
      this.change();
    }
  },
  mounted() {
    this.change();
  },
  methods: {
    change() {
      var clearmap = document.getElementById(this.mapid);
      clearmap.innerHTML = "";
      vectorsource = new VectorSource({
        format: new GeoJSON(),
        url:
          "https://trafficdistillery.com/tracking/getmosaicgraph/" +
          this.$session.get("PROJID") +
          "/" +
          this.obj
      });
      var image = new ImageLayer({
        source: new Static({
          url:
            "https://trafficdistillery.com/sites/default/files/project/" +
            this.$session.get("PROJID") +
            "/images/" +
            this.frame +
            ".jpg",
          projection: projection,
          size: [720, 480],
          imageExtent: extent
        })
      });
      vectorlayer = new VectorLayer({
        source: vectorsource,
        style: function(feature) {
          style.getText().setText(feature.get("label"));
          return style;
        }
      });
      new Map({
        interactions: [select],
        layers: [image, vectorlayer],
        target: this.mapid,
        controls: [],
        view: new View({
          projection: projection,
          center: getCenter(extent),
          zoom: 1.3,
          attribution: true
        })
      });
    }
  }
};
</script>
<style scoped>
.maptrack {
  height: 400px;
  width: 600px;
}
</style>
